import { toast } from "react-toastify";
import dayjs from "dayjs";
import { Toast } from "@/components/Toast";

export interface INotification {
  message: string;
  timestamp: number | Date;
  type: NotificationType;
  title?: string;
  txnLink?: string;
}
export const enum NotificationType {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Info = "info",
}

export const showToastNotification = (notification: INotification) => {
  let toastMethod;
  switch (notification.type) {
    case "error":
      toastMethod = toast.error;
      break;
    case "success":
      toastMethod = toast.success;
      break;
    case "info":
      toastMethod = toast.info;
      break;
    case "warning":
      toastMethod = toast.warning;
      break;
    default:
      toastMethod = toast.info;
  }
  toastMethod(
    <Toast
      toastType={notification.type}
      title={notification.title || ""}
      subTitle={notification.message || ""}
      showClose={false}
      txnLink={notification.txnLink || ""}
      date={dayjs(notification.timestamp).format("YYYY-MM-DD")}
      time={dayjs(notification.timestamp).format("hh:mm A")}
    />,
    {
      toastId: `notif_${notification.timestamp}`,
      autoClose: 7000,
      hideProgressBar: true,
      theme: "colored",
      icon: false,
      onClose: () => {},
    }
  );
};
